import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/**
 * Stops the tab's turn (`turnId`), else the thread's running one. The reply keeps
 * the text sent before `cursor`, or all text streamed so far without one.
 */
export const stopAskRedoTurn = {
  name: "stopAskRedoTurn" as const,
  input: z.object({
    threadId: zExt.objectId(),
    turnId: z.string().optional(),
    cursor: z.number().int().min(0).optional(),
  }),
  output: z.object({ stopped: z.boolean() }),
};
